<div class="title" *ngIf="restaurant" id="title">
  {{restaurant | titleTranslate }}
</div>
